
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34168',
  depVersions: {
  "documents-public-ui": "static-1.34168",
  "client-types": "static-1.454",
  "documents-lib": "static-1.34173",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2001",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4884",
  "highcharts": "static-8.101",
  "hs-promise-utils": "static-1.5470",
  "hs-test-utils": "static-1.7886",
  "hub-http": "static-1.6094",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11318",
  "I18n": "static-7.1598",
  "jasmine-immutable": "static-1.2892",
  "jasmine-runner": "static-1.6345",
  "lodash": "static-1.3",
  "quartz": "static-1.6832",
  "react": "static-7.182",
  "react-dlb": "static-1.74",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16527",
  "reporting-data": "static-1.66877",
  "reporting-testing-lib": "static-1.8810",
  "reporting-visualizations": "static-1.58953",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4643",
  "webpack-env": "static-1.54",
  "atom": "static-1.4945",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2368",
  "classnames": "static-2.10",
  "cssUtils": "static-1.764",
  "customer-data-filters-ui": "static-1.39206",
  "customer-data-objects": "static-1.7529",
  "customer-data-property-utils": "static-1.7957",
  "data-fetching-client": "static-1.9551",
  "enviro": "static-4.416",
  "FireAlarmUi": "static-1.4404",
  "flux-actions": "static-1.323",
  "FormsCommonComponents": "static-1.85497",
  "FormUrlGenerator": "static-2.4595",
  "foundations-components": "static-1.7666",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11626",
  "icons": "static-2.637",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7035",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.377",
  "property-description-translator": "static-1.3729",
  "property-translator": "static-1.5283",
  "quartz-config": "static-1.610",
  "quartz-core": "static-1.6051",
  "quick-fetch": "static-1.3808",
  "raven": "static-3.5768",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5243",
  "react-virtualized": "static-2.96",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8041",
  "reference-resolvers-lite": "static-1.7962",
  "report-customization-components": "static-1.12752",
  "reporting-enablement": "static-1.22388",
  "reporting-reports": "static-1.66555",
  "reporting-snowflake": "static-1.55495",
  "reporting-ui-components": "static-2.64148",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4519",
  "sales-content-partitioning": "static-1.8811",
  "SalesContentIndexUI": "static-3.9031",
  "sanitize": "static-1.4349",
  "sanitize-text": "static-1.8020",
  "self-service-api": "static-1.10117",
  "SharedI18nStrings": "static-1.181",
  "SharedLegalStrings": "static-1.1627",
  "signup-constants": "static-1.18588",
  "signup-ui-lego-core": "static-1.20598",
  "signup-ui-url-generator": "static-2.7911",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4643",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10867",
  "ui-addon-i18n": "static-1.11021",
  "ui-addon-react-router-dom": "static-1.9420",
  "ui-addon-upgrades": "static-9.17787",
  "ui-asset-management-lib": "static-1.10831",
  "ui-images": "static-2.1124",
  "UIComponents": "static-3.8265",
  "usage-tracker": "static-1.7211",
  "usage-tracker-container": "static-1.7201",
  "usage-tracker-core": "static-1.7061",
  "usage-tracker-public": "static-1.7022",
  "viral-links-lib": "static-1.6916",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven-hubspot": "static-1.6075",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3302",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3109",
  "quartz-webpack": "static-1.3056",
  "ai-components-ui-library": "static-1.8593",
  "amplitude-session-replay-browser": "static-1.57",
  "foundations-assets": "static-1.4715",
  "foundations-theming": "static-1.4285",
  "quartz-auth": "static-1.507",
  "ui-business-units-lib": "static-1.8910",
  "usage-tracker-session-replay": "static-1.4897",
  "foundations-theming-base": "static-1.3270",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.69",
  "hs-test-utils-bend-plugin": "static-1.2997",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4200",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7799",
  "graphql": "static-1.79",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3484",
  "persist-promise": "static-1.3584",
  "reporting-client-types": "static-1.2415",
  "foundations-components-legacy": "static-1.691",
  "hs-story-utils": "static-1.9302",
  "react-flip-move": "static-1.67",
  "hub-http-shared-msw-handlers": "static-1.9665",
  "hubspotter-http": "static-1.4548",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7123",
  "crm-message-bus": "static-1.42620",
  "customer-data-filters-ui-msw-helpers": "static-1.21641",
  "customer-data-objects-ui-components": "static-1.12890",
  "customer-data-reference-ui-components": "static-1.13026",
  "customer-data-ui-utilities": "static-1.9699",
  "framework-builder-read-service-client": "static-1.3903",
  "framework-data-schema-quick-fetch": "static-1.6653",
  "framework-data-schema-resolvers": "static-1.6748",
  "inbound-db-properties-service-client": "static-1.3741",
  "multi-account-reference-resolvers": "static-1.855",
  "onboarding-tours": "static-1.16372",
  "reporting-datasets-permissions-lib": "static-1.13292",
  "ui-addon-teams": "static-1.21364",
  "apollo-stack-hubspot": "static-3.83",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67885",
  "customer-data-properties": "static-1.51060",
  "forms-ai-lib": "static-1.4118",
  "forms-utils-lib": "static-1.12332",
  "foundations-components-test-utils": "static-1.5149",
  "react-dnd-compat": "static-1.4494",
  "react-tinymce": "static-1.54861",
  "tinymce-config": "static-2.53987",
  "ui-gdpr-components": "static-1.10223",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3935",
  "floating-ui": "static-1.53",
  "react-aria": "static-1.63",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1433",
  "ui-fonts": "static-1.580",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-head": "static-1.497",
  "quartz-i18n": "static-1.507",
  "quartz-routing": "static-1.262",
  "quartz-test": "static-1.507",
  "quartz-tracking": "static-1.211",
  "batch-promise": "static-1.1427",
  "external-options-client-types": "static-1.4054",
  "react-colorpicker": "static-2.10085",
  "copilot-toolkit": "static-1.10757",
  "data-quality-ui-library": "static-1.12534",
  "html-to-image": "static-1.51",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6338",
  "reporting-action-components": "static-1.40876",
  "reporting-insights-lib": "static-1.1319",
  "reporting-plugins": "static-1.10078",
  "ui-addon-draggable-compat": "static-2.4129",
  "ui-addon-opt": "static-4.8258",
  "ui-shepherd-react": "static-3.10021",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24969",
  "hubspot-apollo-client": "static-1.4754",
  "chirp-fetch": "static-1.1757",
  "sales-templates-service-types-lib": "static-1.4062",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5627",
  "salesImages": "static-1.522",
  "ts-schema": "static-1.3975",
  "timezone-utils": "static-2.5119",
  "bender-build-tools": "static-1.3041",
  "chatspot-core": "static-1.20687",
  "bend-plugin-foundations-theming": "static-1.2768",
  "stylex": "static-1.29",
  "hubspotter-http-shared-msw-handlers": "static-1.9663",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3693",
  "crm-pipelines-api-client-types": "static-1.4037",
  "multi-currency-client-types": "static-1.3585",
  "getting-started-shared-tasks": "static-1.18118",
  "growth-data-modal": "static-1.5235",
  "growth-onboarding-confetti": "static-1.2947",
  "growth-onboarding-next-action-utils": "static-1.1525",
  "navigation-components": "static-1.17554",
  "onboarding-tours-client": "static-1.4586",
  "onboarding-tours-utils": "static-1.438",
  "ui-shepherd-tracker": "static-1.7402",
  "ui-universal-auth": "static-1.8796",
  "user-context": "static-1.4975",
  "cms-field-types": "static-1.4683",
  "content-icons-ui": "static-1.2188",
  "integrations-lib": "static-1.15681",
  "calling-global-api": "static-1.63992",
  "calling-internal-common": "static-1.31175",
  "calling-lifecycle-internal": "static-1.65374",
  "calling-lifecycle-messages": "static-1.57668",
  "commerce-products-lib": "static-1.9069",
  "crm-links": "static-1.6146",
  "file-manager-components": "static-1.23178",
  "google-libphonenumber": "static-1.35",
  "hs-resources": "static-1.8",
  "inbounddb-objects-service-types": "static-1.4118",
  "meetings-icalendar-utils-lib": "static-1.506",
  "object-builder-ui-client": "static-1.48294",
  "pipeline-validation-client-types": "static-1.3859",
  "property-value-citations": "static-1.1674",
  "pulse": "static-1.406",
  "smart-property-lib": "static-1.6283",
  "tiered-pricing": "static-1.962",
  "ui-addon-iframeable": "static-1.8923",
  "final-form": "static-1.67",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19609",
  "tinymce-themes": "static-1.55957",
  "data-token-picker": "static-1.16180",
  "hub-http-contrib": "static-1.2918",
  "interframe": "static-3.4637",
  "tinymce-data": "static-1.40072",
  "tinymce-plugins": "static-1.57101",
  "ui-addon-sales-email": "static-1.5087",
  "magpie-lib": "static-1.5469",
  "magpie-types": "static-1.4929",
  "simple-logging-lib": "static-1.2925",
  "content-assistance-lib": "static-1.7558",
  "dashboard-lib": "static-1.80971",
  "ExportDialog": "static-6.10264",
  "hubspot-prosemirror": "static-1.17850",
  "hubspot-prosemirror-plugins": "static-1.17842",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8568",
  "campaign-roi-lib": "static-1.8531",
  "feedback-loader": "static-1.29039",
  "apollo-link-hub-http": "static-2.4526",
  "hubspot-apollo-cache": "static-1.213",
  "growth-monetization-service-types": "static-1.4373",
  "nav-client-types": "static-1.2232",
  "purchase-motions-api": "static-1.5630",
  "trials-service-types": "static-1.3774",
  "growth-onboarding-next-action-components": "static-1.1553",
  "user-context-client": "static-1.4487",
  "idb-keyval": "static-1.41",
  "reactive-lib": "static-1.599",
  "unified-auth-core-lib": "static-1.591",
  "getting-started-shared-tasks-store": "static-1.17236",
  "integrations-error-boundary-lib": "static-1.13096",
  "integrations-tracking-lib": "static-1.5467",
  "native-integrations-shared-strings": "static-1.7661",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10249",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.310",
  "calling-error-reporting": "static-1.31181",
  "shared-worker-versioning": "static-1.10914",
  "calling-usage-tracker": "static-1.6416",
  "voice-sms-access-library": "static-1.496",
  "customer-data-tracking": "static-1.6758",
  "commerce-permissions": "static-1.639",
  "products-iframe-lib": "static-1.7557",
  "products-ui-components-shared-msw-handlers": "static-1.10047",
  "location-customization-utils-lib": "static-1.8824",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4028",
  "video-components-external": "static-1.10833",
  "video-data-lib": "static-1.34491",
  "directed-graph": "static-1.813",
  "event-emitter": "static-1.822",
  "fast-json-patch": "static-1.60",
  "breeze-intelligence-kit": "static-1.5431",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9748",
  "fsm": "static-1.3606",
  "policy-lib": "static-1.6654",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9811",
  "navigation-messaging": "static-1.6881",
  "FileManagerLib": "static-1.38818",
  "NamespacedHubStyle": "static-2.8964",
  "FileManagerCore": "static-1.38677",
  "codemirror": "static-5.92",
  "layout-dnd-components": "static-1.12196",
  "layout-dnd-utils": "static-1.11171",
  "react-codemirror": "static-1.10499",
  "ui-addon-emoji-picker": "static-1.9762",
  "ui-brand-identity-lib": "static-1.14480",
  "ui-addon-video-player": "static-1.8569",
  "ui-coaching-tips": "static-1.28166",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8433",
  "payment-link-components": "static-1.23158",
  "EmailSignatureEditor": "static-1.24073",
  "eligibility-engine-service-types": "static-1.3055",
  "universal-page-editor-lib": "static-1.2877",
  "calling-orchestration-schema": "static-1.35273",
  "sales-views-client-types": "static-1.4138",
  "crm-record-cards-service-types": "static-1.3512",
  "content-media-composition-data-lib": "static-1.11779",
  "content-media-compositions": "static-2.15786",
  "media-bridge-lib": "static-1.18700",
  "trellis-story-utils": "static-1.4395",
  "storybook-react": "static-1.30",
  "audio-components": "static-1.5721",
  "FileManagerImages": "static-1.36329",
  "video-components": "static-1.12836",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4407",
  "video-embed": "static-1.35325",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67960",
  "layout-data-lib": "static-1.9496",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6456",
  "commerce-tours-lib": "static-1.5855",
  "growth-onboarding-reliability": "static-1.4961",
  "sales-checkout-service-client": "static-1.3543",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21447",
  "sales-email-signature-service-client": "static-1.3718",
  "social-insights-client-types": "static-1.21666",
  "outpost": "static-1.4073",
  "advanced-menus-core": "static-1.14928",
  "advanced-menus-lib": "static-1.11894",
  "ui-memberships-settings-lib": "static-1.33674",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14927",
  "simple-menus-lib": "static-1.16444"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34168",
  "client-types": "/client-types/static-1.454",
  "documents-lib": "/documents-lib/static-1.34173",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2001",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4884",
  "highcharts": "/highcharts/static-8.101",
  "hs-promise-utils": "/hs-promise-utils/static-1.5470",
  "hs-test-utils": "/hs-test-utils/static-1.7886",
  "hub-http": "/hub-http/static-1.6094",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11318",
  "I18n": "/I18n/static-7.1598",
  "jasmine-immutable": "/jasmine-immutable/static-1.2892",
  "jasmine-runner": "/jasmine-runner/static-1.6345",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6832",
  "react": "/react/static-7.182",
  "react-dlb": "/react-dlb/static-1.74",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16527",
  "reporting-data": "/reporting-data/static-1.66877",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8810",
  "reporting-visualizations": "/reporting-visualizations/static-1.58953",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4643",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4945",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2368",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.764",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39206",
  "customer-data-objects": "/customer-data-objects/static-1.7529",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7957",
  "data-fetching-client": "/data-fetching-client/static-1.9551",
  "enviro": "/enviro/static-4.416",
  "FireAlarmUi": "/FireAlarmUi/static-1.4404",
  "flux-actions": "/flux-actions/static-1.323",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85497",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4595",
  "foundations-components": "/foundations-components/static-1.7666",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11626",
  "icons": "/icons/static-2.637",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7035",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "property-description-translator": "/property-description-translator/static-1.3729",
  "property-translator": "/property-translator/static-1.5283",
  "quartz-config": "/quartz-config/static-1.610",
  "quartz-core": "/quartz-core/static-1.6051",
  "quick-fetch": "/quick-fetch/static-1.3808",
  "raven": "/raven/static-3.5768",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5243",
  "react-virtualized": "/react-virtualized/static-2.96",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8041",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7962",
  "report-customization-components": "/report-customization-components/static-1.12752",
  "reporting-enablement": "/reporting-enablement/static-1.22388",
  "reporting-reports": "/reporting-reports/static-1.66555",
  "reporting-snowflake": "/reporting-snowflake/static-1.55495",
  "reporting-ui-components": "/reporting-ui-components/static-2.64148",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4519",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8811",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9031",
  "sanitize": "/sanitize/static-1.4349",
  "sanitize-text": "/sanitize-text/static-1.8020",
  "self-service-api": "/self-service-api/static-1.10117",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1627",
  "signup-constants": "/signup-constants/static-1.18588",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20598",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7911",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4643",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10867",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11021",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9420",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17787",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10831",
  "ui-images": "/ui-images/static-2.1124",
  "UIComponents": "/UIComponents/static-3.8265",
  "usage-tracker": "/usage-tracker/static-1.7211",
  "usage-tracker-container": "/usage-tracker-container/static-1.7201",
  "usage-tracker-core": "/usage-tracker-core/static-1.7061",
  "usage-tracker-public": "/usage-tracker-public/static-1.7022",
  "viral-links-lib": "/viral-links-lib/static-1.6916",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3302",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3109",
  "quartz-webpack": "/quartz-webpack/static-1.3056",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8593",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4715",
  "foundations-theming": "/foundations-theming/static-1.4285",
  "quartz-auth": "/quartz-auth/static-1.507",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8910",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4897",
  "foundations-theming-base": "/foundations-theming-base/static-1.3270",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2997",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4200",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7799",
  "graphql": "/graphql/static-1.79",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
  "persist-promise": "/persist-promise/static-1.3584",
  "reporting-client-types": "/reporting-client-types/static-1.2415",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.691",
  "hs-story-utils": "/hs-story-utils/static-1.9302",
  "react-flip-move": "/react-flip-move/static-1.67",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9665",
  "hubspotter-http": "/hubspotter-http/static-1.4548",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7123",
  "crm-message-bus": "/crm-message-bus/static-1.42620",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21641",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12890",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13026",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9699",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3903",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6653",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6748",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3741",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.855",
  "onboarding-tours": "/onboarding-tours/static-1.16372",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13292",
  "ui-addon-teams": "/ui-addon-teams/static-1.21364",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.83",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67885",
  "customer-data-properties": "/customer-data-properties/static-1.51060",
  "forms-ai-lib": "/forms-ai-lib/static-1.4118",
  "forms-utils-lib": "/forms-utils-lib/static-1.12332",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5149",
  "react-dnd-compat": "/react-dnd-compat/static-1.4494",
  "react-tinymce": "/react-tinymce/static-1.54861",
  "tinymce-config": "/tinymce-config/static-2.53987",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10223",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3935",
  "floating-ui": "/floating-ui/static-1.53",
  "react-aria": "/react-aria/static-1.63",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1433",
  "ui-fonts": "/ui-fonts/static-1.580",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-head": "/quartz-head/static-1.497",
  "quartz-i18n": "/quartz-i18n/static-1.507",
  "quartz-routing": "/quartz-routing/static-1.262",
  "quartz-test": "/quartz-test/static-1.507",
  "quartz-tracking": "/quartz-tracking/static-1.211",
  "batch-promise": "/batch-promise/static-1.1427",
  "external-options-client-types": "/external-options-client-types/static-1.4054",
  "react-colorpicker": "/react-colorpicker/static-2.10085",
  "copilot-toolkit": "/copilot-toolkit/static-1.10757",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12534",
  "html-to-image": "/html-to-image/static-1.51",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6338",
  "reporting-action-components": "/reporting-action-components/static-1.40876",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1319",
  "reporting-plugins": "/reporting-plugins/static-1.10078",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4129",
  "ui-addon-opt": "/ui-addon-opt/static-4.8258",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10021",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24969",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4754",
  "chirp-fetch": "/chirp-fetch/static-1.1757",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4062",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5627",
  "salesImages": "/salesImages/static-1.522",
  "ts-schema": "/ts-schema/static-1.3975",
  "timezone-utils": "/timezone-utils/static-2.5119",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "chatspot-core": "/chatspot-core/static-1.20687",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2768",
  "stylex": "/stylex/static-1.29",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9663",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3693",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4037",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3585",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18118",
  "growth-data-modal": "/growth-data-modal/static-1.5235",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2947",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1525",
  "navigation-components": "/navigation-components/static-1.17554",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4586",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.438",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7402",
  "ui-universal-auth": "/ui-universal-auth/static-1.8796",
  "user-context": "/user-context/static-1.4975",
  "cms-field-types": "/cms-field-types/static-1.4683",
  "content-icons-ui": "/content-icons-ui/static-1.2188",
  "integrations-lib": "/integrations-lib/static-1.15681",
  "calling-global-api": "/calling-global-api/static-1.63992",
  "calling-internal-common": "/calling-internal-common/static-1.31175",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65374",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57668",
  "commerce-products-lib": "/commerce-products-lib/static-1.9069",
  "crm-links": "/crm-links/static-1.6146",
  "file-manager-components": "/file-manager-components/static-1.23178",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "hs-resources": "/hs-resources/static-1.8",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4118",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.506",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48294",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3859",
  "property-value-citations": "/property-value-citations/static-1.1674",
  "pulse": "/pulse/static-1.406",
  "smart-property-lib": "/smart-property-lib/static-1.6283",
  "tiered-pricing": "/tiered-pricing/static-1.962",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8923",
  "final-form": "/final-form/static-1.67",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19609",
  "tinymce-themes": "/tinymce-themes/static-1.55957",
  "data-token-picker": "/data-token-picker/static-1.16180",
  "hub-http-contrib": "/hub-http-contrib/static-1.2918",
  "interframe": "/interframe/static-3.4637",
  "tinymce-data": "/tinymce-data/static-1.40072",
  "tinymce-plugins": "/tinymce-plugins/static-1.57101",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5087",
  "magpie-lib": "/magpie-lib/static-1.5469",
  "magpie-types": "/magpie-types/static-1.4929",
  "simple-logging-lib": "/simple-logging-lib/static-1.2925",
  "content-assistance-lib": "/content-assistance-lib/static-1.7558",
  "dashboard-lib": "/dashboard-lib/static-1.80971",
  "ExportDialog": "/ExportDialog/static-6.10264",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17850",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17842",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8568",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8531",
  "feedback-loader": "/feedback-loader/static-1.29039",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4526",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.213",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4373",
  "nav-client-types": "/nav-client-types/static-1.2232",
  "purchase-motions-api": "/purchase-motions-api/static-1.5630",
  "trials-service-types": "/trials-service-types/static-1.3774",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1553",
  "user-context-client": "/user-context-client/static-1.4487",
  "idb-keyval": "/idb-keyval/static-1.41",
  "reactive-lib": "/reactive-lib/static-1.599",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.591",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17236",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13096",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5467",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7661",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10249",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.310",
  "calling-error-reporting": "/calling-error-reporting/static-1.31181",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10914",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6416",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.496",
  "customer-data-tracking": "/customer-data-tracking/static-1.6758",
  "commerce-permissions": "/commerce-permissions/static-1.639",
  "products-iframe-lib": "/products-iframe-lib/static-1.7557",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10047",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8824",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4028",
  "video-components-external": "/video-components-external/static-1.10833",
  "video-data-lib": "/video-data-lib/static-1.34491",
  "directed-graph": "/directed-graph/static-1.813",
  "event-emitter": "/event-emitter/static-1.822",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5431",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9748",
  "fsm": "/fsm/static-1.3606",
  "policy-lib": "/policy-lib/static-1.6654",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9811",
  "navigation-messaging": "/navigation-messaging/static-1.6881",
  "FileManagerLib": "/FileManagerLib/static-1.38818",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8964",
  "FileManagerCore": "/FileManagerCore/static-1.38677",
  "codemirror": "/codemirror/static-5.92",
  "layout-dnd-components": "/layout-dnd-components/static-1.12196",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11171",
  "react-codemirror": "/react-codemirror/static-1.10499",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9762",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14480",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8569",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28166",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8433",
  "payment-link-components": "/payment-link-components/static-1.23158",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24073",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3055",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2877",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35273",
  "sales-views-client-types": "/sales-views-client-types/static-1.4138",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3512",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11779",
  "content-media-compositions": "/content-media-compositions/static-2.15786",
  "media-bridge-lib": "/media-bridge-lib/static-1.18700",
  "trellis-story-utils": "/trellis-story-utils/static-1.4395",
  "storybook-react": "/storybook-react/static-1.30",
  "audio-components": "/audio-components/static-1.5721",
  "FileManagerImages": "/FileManagerImages/static-1.36329",
  "video-components": "/video-components/static-1.12836",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4407",
  "video-embed": "/video-embed/static-1.35325",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67960",
  "layout-data-lib": "/layout-data-lib/static-1.9496",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6456",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5855",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4961",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3543",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21447",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3718",
  "social-insights-client-types": "/social-insights-client-types/static-1.21666",
  "outpost": "/outpost/static-1.4073",
  "advanced-menus-core": "/advanced-menus-core/static-1.14928",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11894",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33674",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14927",
  "simple-menus-lib": "/simple-menus-lib/static-1.16444"
}
};
